import { render, staticRenderFns } from "./PhotosTab.vue?vue&type=template&id=775d2d74&scoped=true"
import script from "./PhotosTab.vue?vue&type=script&lang=js"
export * from "./PhotosTab.vue?vue&type=script&lang=js"
import style0 from "./PhotosTab.vue?vue&type=style&index=0&id=775d2d74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775d2d74",
  null
  
)

export default component.exports